const getIsBusinessEmail = ({ email }) => {
  return !/gmail|yahoo|bing|hotmail|aol|outlook|icloud|\.edu/i.test(email);
};

export default getIsBusinessEmail;
